import { ITssHttpParams }        from '@core/interfaces/api.interface';
import { AllowedDetailsTabEnum } from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                from '@core/interfaces/route.interface';


export enum TssRoutesEnum {
	ListPage = '',
	DetailPage = ':tssId',
	DetailPageTab = ':tssId/:tab',
	FormPageUpdate = ':tssId/:tab/update',
	// External
	ExternalListPage = 'external',
	ExternalDetailPage = 'external/:tssId',
	ExternalDetailPageTab = 'external/:tssId/:tab',
	ExternalFormPageCreate = 'external/create',
	ExternalFormPageUpdate = 'external/:tssId/update'
}


// Base
export interface TssListPageBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tss;
	queryParams?: ITssHttpParams;
}

export interface TssDetailPageBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tss;
	params: { tssId: string };
}

export interface TssDetailPageTabBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tss;
	params: {
		tab: AllowedDetailsTabEnum,
		tssId: string
	};
	replaceLastStoredRouteWithNew: boolean;
}

export interface TssFormPageUpdateBaseRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tss;
	params: { tssId: string };
}

// Tss
export interface TssListPageRoute extends TssListPageBaseRoute {
	path: TssRoutesEnum.ListPage;
}

export interface TssDetailPageRoute extends TssDetailPageBaseRoute {
	path: TssRoutesEnum.DetailPage;
}

export interface TssDetailPageTabRoute extends TssDetailPageTabBaseRoute {
	path: TssRoutesEnum.DetailPageTab;
}

export interface TssFormPageUpdateRoute extends TssFormPageUpdateBaseRoute {
	path: TssRoutesEnum.FormPageUpdate;
	params: { tssId: string };
}

// External
export interface TssExternalListPageRoute extends TssListPageBaseRoute {
	path: TssRoutesEnum.ExternalListPage;
}

export interface TssExternalDetailPageRoute extends TssDetailPageBaseRoute {
	path: TssRoutesEnum.ExternalDetailPage;
}

export interface TssExternalDetailPageTabRoute extends TssDetailPageTabBaseRoute {
	path: TssRoutesEnum.ExternalDetailPageTab;
}

export interface TssExternalFormPageUpdateRoute extends TssFormPageUpdateBaseRoute {
	path: TssRoutesEnum.ExternalFormPageUpdate;
	params: { tssId: string };
}
